import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import React from 'react';

import appEnums from 'enums/app';
import configSelectors from 'selectors/configuration';
import ConnectionErrorBannerContainer from 'presentation/containers/ConnectionErrorBannerContainer';
import CompositionContainer from 'presentation/containers/CompositionContainer';
import { getAttachmentsEnabled, getChatClientConnectionStatus, getUserName, getUserEmail } from 'app/modules';
import EmailValidationCompositionContainer from '../selfService/containers/EmailValidationCompositionContainer';
import MessageValidationCompositionContainer from '../selfService/containers/MessageValidationCompositionContainer';
import NameValidationCompositionContainer from '../selfService/containers/NameValidationCompositionContainer';

export function Footer(props) {
  Footer.propTypes = {
    canAddAttachments: PropTypes.bool,
    email: PropTypes.string,
    name: PropTypes.string,
    isChatClientConnected: PropTypes.bool.isRequired,
    isChatClientReconnecting: PropTypes.bool.isRequired,
  };

  function renderComposition() {
    if (props.isOnboardingEnabled) {
      if (!props.email) {
        return <EmailValidationCompositionContainer isChatClientConnected={props.isChatClientConnected} />;
      } else if (!props.name) {
        return (
          <NameValidationCompositionContainer email={props.email} isChatClientConnected={props.isChatClientConnected} />
        );
      }
    }

    if (!props.canAddAttachments) {
      return <CompositionContainer isChatClientConnected={props.isChatClientConnected} />;
    }

    return <MessageValidationCompositionContainer isChatClientConnected={props.isChatClientConnected} />;
  }

  return (
    <React.Fragment>
      <ConnectionErrorBannerContainer
        isChatClientConnected={props.isChatClientConnected}
        isChatClientReconnecting={props.isChatClientReconnecting}
      />
      {renderComposition()}
    </React.Fragment>
  );
}

export const mapStateToProps = (state, props) => {
  const chatClientConnectionStatus = getChatClientConnectionStatus(state);
  const { CONNECTED, RECONNECTING } = appEnums.chatClientConnectionStatuses;

  return {
    ...props,
    canAddAttachments: getAttachmentsEnabled(state),
    name: getUserName(state),
    email: getUserEmail(state),
    isChatClientConnected: !chatClientConnectionStatus || chatClientConnectionStatus === CONNECTED,
    isChatClientReconnecting: chatClientConnectionStatus === RECONNECTING,
    isOnboardingEnabled: configSelectors.getOnboardingEnabled(state.configuration),
  };
};

const FooterContainer = connect(mapStateToProps)(Footer);

export default FooterContainer;
